import React from 'react';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductCatering } from 'Components/widgets/product-catering/ProductCatering';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import type { LineProps } from './resolver';

const ProductBarsLine = ({ config, bars, title, priceInclude, withSupplement }: LineProps) => {
  const { introduction, barsList = [] } = bars ?? {};
  if (!config) {
    return null;
  }

  const intros = introduction
    ? [
        {
          title: priceInclude,
          description: introduction.included,
        },
        {
          title: withSupplement,
          description: introduction.withSupplement,
        },
      ]
    : [];
  const list = barsList.map((bar) => {
    const [image] = bar.images;
    return { ...bar, image };
  });
  return (
    <SiteContainer className="Line">
      <LineTitle>{title}</LineTitle>
      <ProductCatering
        intros={intros}
        list={list}
        seeLessLabel={config.common.loadLess}
        seeMoreLabel={config.common.viewMore}
      />
    </SiteContainer>
  );
};

export default ProductBarsLine;
